export const CLOSE_ALL_MODALS = "CLOSE_ALL_MODALS";
export const OPEN_REF_MODAL = "OPEN_REF_MODAL";
export const OPEN_PASSWORD_MODAL = "OPEN_PASSWORD_MODAL";
export const OPEN_UNIT_CALC_MODAL = "OPEN_UNIT_CALC_MODAL";
export const OPEN_MOBILE_DOWNLOAD_MODAL = "OPEN_MOBILE_DOWNLOAD_MODAL";
export const CLOSE_FIXED_MODAL = "CLOSE_FIXED_MODAL";
export const OPEN_FIXED_MODAL = "OPEN_FIXED_MODAL";
export const FULLY_DISMISS_MODAL = "FULLY_DISMISS_MODAL";
export const OPEN_DELETE_METER_MODAL = "OPEN_DELETE_METER_MODAL";
export const TOGGLE_WARNING_MODAL = "TOGGLE_WARNING_MODAL";
export const TOGGLE_TICKET_SUCCESS_MODAL = "TOGGLE_TICKET_SUCCESS_MODAL";
export const TOGGLE_DUPLICATE_TRANSACTION_MODAL =
  "TOGGLE_DUPLICATE_TRANSACTION_MODAL";
export const OPEN_REFUND_MODAL = "OPEN_REFUND_MODAL";
export const OPEN_TOPUP_MODAL = "OPEN_TOPUP_MODAL";
export const OPEN_PASSWORD_RESET_NOTIFICATION_MODAL =
  "OPEN_PASSWORD_RESET_NOTIFICATION_MODAL";
export const OPEN_VTU_DATA_OPTION_MODAL = "OPEN_VTU_DATA_OPTION_MODAL";
export const OPEN_REFERRAL_PROGRESS_MODAL = "OPEN_REFERRAL_PROGRESS_MODAL";

export const closeAllModals = () => ({ type: CLOSE_ALL_MODALS });

export const openRefModal = () => ({ type: OPEN_REF_MODAL });

export const openPasswordModal = () => ({ type: OPEN_PASSWORD_MODAL });

export const openUnitCalcModal = (data) => ({
  type: OPEN_UNIT_CALC_MODAL,
  data,
});

export const openMobileDownloadModal = (data = {}) => ({
  type: OPEN_MOBILE_DOWNLOAD_MODAL,
  data,
});

export const openDeleteMeterModal = (data) => ({
  type: OPEN_DELETE_METER_MODAL,
  data,
});

export const closeFixedModal = () => ({ type: CLOSE_FIXED_MODAL });

export const openFixedModal = () => ({ type: OPEN_FIXED_MODAL });

export const fullyDismissModal = () => ({ type: FULLY_DISMISS_MODAL });

export const toggleTicketSuccessModal = (data) => ({
  type: TOGGLE_TICKET_SUCCESS_MODAL,
  data,
});

export const toggleWarningModal = (data) => ({
  type: TOGGLE_WARNING_MODAL,
  data,
});

export const toggleDuplicateTransactionModal = (data = { open: true }) => ({
  type: TOGGLE_DUPLICATE_TRANSACTION_MODAL,
  data,
});

export const openRefundModal = (data) => ({
  type: OPEN_REFUND_MODAL,
  data,
});

export const openTopUpModal = (data) => ({
  type: OPEN_TOPUP_MODAL,
  data,
});
export const openPasswordResetNotifyModal = (data) => ({
  type: OPEN_PASSWORD_RESET_NOTIFICATION_MODAL,
  data,
});

export const openVtuDataOption = (data) => ({
  type: OPEN_VTU_DATA_OPTION_MODAL,
  data,
});

export const openReferralProgressModal = (data = {}) => ({
  type: OPEN_REFERRAL_PROGRESS_MODAL,
  data,
});



// WEBPACK FOOTER //
// ./src/actions/modalActions.js